export const MODAL_TITLE = 'Detalhes da solicitação';
export const CLOSE_LABEL = 'Fechar';
export const DOWNLOAD_RECEIPT_LABEL = 'Baixar recibo';
export const TIMELINE_TITLE = 'Acompanhamento';
export const TIMELINE_TITLE_ID = 'vacation-request-timeline-title';
export const NO_DATE_LABEL = '—';

export const DELETE_REQUEST_LABEL = 'Excluir solicitação';
export const DELETE_WARNING = 'A solicitação será apagada e não poderá ser recuperada.';
export const DELETE_KEEP_LABEL = 'Manter solicitação';
export const DELETE_CONFIRM_LABEL = 'Excluir';

export const CONFIRM_REQUEST_LABEL = 'Confirmar solicitação';
export const CONFIRM_WARNING = 'A solicitação seguirá para o gestor agora e você não poderá mais excluí-la.';
export const CONFIRM_KEEP_LABEL = 'Aguardar';
export const CONFIRM_SEND_LABEL = 'Enviar';

export function buildDraftCountdownLabel(remainingLabel: string): string {
    return `Você pode excluir esta solicitação por mais ${remainingLabel}.`;
}

export const CLIENTS_TITLE = 'Clientes';
export const CLIENT_STATUS_PENDING = 'Aguardando confirmação';
export const CLIENT_STATUS_REJECTED = 'Recusou';
export const CLIENT_STATUS_CONFIRMED = 'Confirmou';
export const CLIENT_STATUS_NOT_NEEDED = 'Não precisou confirmar';

export const RESEND_TOOLTIP = 'Reenviar e-mail';
export const RESEND_COOLDOWN_MESSAGE = 'Envio recente, verifique com o Cliente';
export const RESEND_KEEP_LABEL = 'Voltar';
export const RESEND_CONFIRM_LABEL = 'Enviar';

export function buildResendQuestion(email: string): string {
    return `Reenviar o link para ${email}?`;
}

export function buildResendAriaLabel(email: string, canResend: boolean): string {
    if (canResend) {
        return `Reenviar e-mail de aprovação para ${email}`;
    }
    return `Envio recente para ${email}`;
}

export const ACTION_BUTTON_CLASSES = {
    normal: 'px-5 py-2.5 text-sm',
    compact: 'px-3 py-1.5 text-xs',
    compactWarning: 'text-xs',
    normalWarning: 'text-xs',
};
